import { Control, FieldPath, FieldValues } from 'react-hook-form'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../select'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '.'

interface SelectOption {
    value: string
    label: string
}

interface FormSelectProps<T extends FieldValues> extends React.InputHTMLAttributes<HTMLInputElement> {
    control: Control<T>
    name: FieldPath<T>
    label?: React.ReactNode
    options: SelectOption[]
}

export default function FormSelect<T extends FieldValues>({
    control,
    name,
    label,
    placeholder,
    options,
    className,
    disabled,
}: FormSelectProps<T>) {
    return (
        <FormItem className={className}>
            <FormField
                control={control}
                name={name}
                render={({ field }) => (
                    <FormItem>
                        {label && <FormLabel>{label}</FormLabel>}
                        <FormControl>
                            <Select {...field} disabled={disabled} onValueChange={v => field.onChange(v)}>
                                <SelectTrigger>
                                    <SelectValue placeholder={placeholder} />
                                </SelectTrigger>
                                <SelectContent>
                                    {options.map(option => (
                                        <SelectItem key={option.value} value={option.value}>
                                            {option.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </FormItem>
    )
}
